<template>
  <div id="leaderBoardModal" class="offcanvas-background">
    <div class="offcanvas offcanvas-right"
         v-click-outside="close">
      <div class="offcanvas-header d-flex align-items-center justify-content-between pb-4">
        <div class="d-flex align-items-center">
          <inline-svg :src="require('@/assets/images/icons/Icon_Leaderboard.svg')"
                      class="mr-3"
                      width="40" height="40"/>
          <span class="font-weight-light" style="font-size: 2.5rem">
          {{$t('app.label.leaderboard')}}
        </span>
        </div>
        <span class="btn btn-xs btn-icon btn-hover-primary ml-auto"
           @click="close">
          <inline-svg :src="require('@/assets/images/icons/Icon_Cancel.svg')"
                      width="20" height="20"/>
        </span>
      </div>
      <div class="offcanvas-content h-100 pb-8">
        <div v-if="courseWithLeaderboard.length > 1"> {{$t('app.label.leaderboard.select')}}
          <select name="courseSelect"
                  class="my-3 custom-select"
                  @change="updateParams($event)"
                  v-model="courseSelect">
            <option value="all" selected> {{$t('app.label.leaderboard.general')}}</option>
            <option v-for="course in courseWithLeaderboard"
                    :key="course.id"
                    :value="course.id">{{course.name}}</option>
          </select>
        </div>
        <div class="resources-list">
          <div class="overflow-sm-x-auto">
              <table class="table table-borderless  table-middle text-center"
                     style="max-height:70vh;" >
                <thead>
                <tr class="rank">
                  <th style="width:10%"> {{$t('app.label.leaderboard.rank')}} </th>
                  <th style="width:35%"> {{$t('app.label.leaderboard.player')}}</th>
                  <th v-if="courseSelect !== 'all' || courseWithLeaderboard.length === 1"
                      style="width:20%">
                    {{$t('app.label.leaderboard.score')}} </th>
                </tr>
                </thead>
                <tbody>
                <tr :class="{'table-selected-line': player.id === currentSession.attendee}"
                    v-for="player in leaderboard.leaderboard" :key="player.id">
                  <td> {{player.rank }}</td>
                  <td> {{player.first_name | str_limit(25)}}
                    <b>{{player.last_name.toUpperCase() | str_limit(25) }}</b></td>
                  <td v-if="courseSelect !== 'all' || courseWithLeaderboard.length === 1">
                    {{player.total }}</td>
                </tr>
                </tbody>
              </table>
              <div class="d-flex align-self-center justify-content-between mb-2">
                  <div v-if="leaderboard.total_users > 0">
                    <span> {{ $t("app.table.show") }} {{ leaderboardsParams.min }} -
                      {{ getToTableResult() }} {{ $t("app.table.of") }}
                      {{ leaderboard.total_users }}</span>
                  </div>
                  <div class="d-flex cursor-hand">
                  <a v-if="leaderboardsParams.min !== 1"
                     @click="showPrevious()">
                    <img
                      class="w-16px d-flex justify-content-center rotate-left-arrow" alt=""
                      src="@/assets/images/icons/Icon_Right_Arrow.svg">
                  </a>
                  <span v-if="leaderboardsParams.min !== 1 ||
                  (leaderboardsParams.min + leaderboardsParams.max) < leaderboard.total_users"
                    class="w-16px d-flex justify-content-center current-page mr-1 ml-1">
                    {{ currentPage }}
                  </span>
                  <a v-if="(leaderboardsParams.min + leaderboardsParams.max)
                  < leaderboard.total_users"
                     @click="showNext()">
                    <img class="w-16px d-flex justify-content-center" alt=""
                         src="@/assets/images/icons/Icon_Right_Arrow.svg">
                  </a>
                  </div>
              </div>
              <a class="btn btn-outline-primary"
                 :class="{'btn-deactivated disabled':leaderboard.user_is_present
                 || leaderboard.user_position === -1}"
                 @click="findMe()">
                {{$t('app.label.leaderboard.find.me')}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import { mapGetters } from 'vuex';
import { FETCH_LEADERBOARDS } from '@/store/actions.type';

export default {
  name: 'SessionLeaderboardsModal',
  props: {
    showModal: Boolean,
  },
  computed: {
    courseWithLeaderboard() {
      // eslint-disable-next-line max-len
      return this.courses.filter((course) => course.leader_board !== null && course.leader_board > 0);
    },
    ...mapGetters(['currentSession', 'leaderboard', 'courses', 'organization']),
  },
  data() {
    return {
      loading: false,
      leaderboardsParams: {
        course: 'all',
        min: 1,
        max: 10,
      },
      leaderBoardModal: true,
      courseSelect: 'all',
      currentPage: 1,
    };
  },
  methods: {
    blockedText(condition) {
      return this.$t('resource.label.access.condition') + condition;
    },
    findMe() {
      this.leaderboardsParams.min = (this.leaderboard.user_position - 10) >= 1
        ? (this.leaderboard.user_position - 10) : 1;
      this.newApiCall();
    },
    showNext() {
      this.currentPage += 1;
      const minValue = this.leaderboard.total_users - 10 >= 1
        ? this.leaderboard.total_users - 10 : 1;
      this.leaderboardsParams.min = (this.leaderboardsParams.min + 10)
      >= this.leaderboard.total_users - 10
        ? minValue : (this.leaderboardsParams.min + 10);
      this.newApiCall();
    },
    showPrevious() {
      this.currentPage -= 1;
      this.leaderboardsParams.min = (this.leaderboardsParams.min - 10)
      >= 1 ? (this.leaderboardsParams.min - 10) : 1;
      this.newApiCall();
    },
    updateParams(newProps) {
      this.leaderboardsParams.course = newProps.target.value;
      this.currentPage = 1;
      this.leaderboardsParams.min = 1;
      this.leaderboardsParams.max = 10;
      this.newApiCall();
    },
    newApiCall() {
      this.isLoading = true;
      store.dispatch(FETCH_LEADERBOARDS, this.leaderboardsParams).then(() => {
        this.isLoading = false;
        this.$Progress.finish();
      });
    },
    getToTableResult() {
      if (this.leaderboardsParams.max < this.leaderboard.total_users) {
        return this.leaderboardsParams.max;
      }
      return this.leaderboard.total_users;
    },
    close() {
      if (document.getElementById('leaderBoardModal').classList.contains('offcanvas-on')) {
        this.$emit('close', { src: 'leaderboard' });
      }
    },
  },
};
</script>

<style scoped>

</style>
